import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '30vh',
    background: `linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 73.44%), url(${process.env.PUBLIC_URL}/images/new_blueprint_1440_400.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '50vh',
      backgroundPosition: 'center',
    },
  },
}));

export default function HeadSection() {
  const classes = useStyles();
  return (
    <Fragment>
      <div className={classes.wrapper} />
    </Fragment>
  );
}
